// Aggregate only commune scopes in the selected COMMUNE_DETAIL section.
// Group within each parent branch so equal codes in different trees stay separate.
export const aggregateCommuneItems = (items, scopeIds) => {
  const includedScopes = new Set(scopeIds);
  const aggregate = (rows, parentId = null, parentPath = []) => {
    const groups = new Map();
    rows.forEach((item) => {
      const isParent = Boolean(item.children?.length || item.hasChildren);
      const key = JSON.stringify([item.itemCode || "", item.itemName || "", item.difficultyLevel ?? "", item.unit || "", isParent]);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });
    return [...groups.entries()].map(([key, sources]) => {
      const first = sources[0];
      const path = [...parentPath, key];
      const itemId = `total-${JSON.stringify(path)}`;
      const children = aggregate(sources.flatMap((item) => item.children || []), itemId, path);
      const isParent = Boolean(children.length || first.hasChildren);
      return {
        ...first,
        itemId,
        parentItemId: parentId,
        contractItemScopeId: null,
        children,
        hasChildren: isParent,
        isCalculatedTotal: true,
        sourceItems: sources,
        contractQuantity: isParent ? 0 : sources.reduce((total, item) => total + Number(item.contractQuantity || 0), 0),
        contractAmount: isParent
          ? children.reduce((total, item) => total + item.contractAmount, 0)
          : sources.reduce((total, item) => total + Number(item.contractAmount ?? (Number(item.contractQuantity || 0) * Number(item.unitPrice || 0))), 0),
        completionPercentage: sources.reduce((total, item) => total + Number(item.completionPercentage || 0), 0) / sources.length,
      };
    });
  };
  return aggregate(items.filter((item) => includedScopes.has(item.contractItemScopeId)));
};

// Remap each source payment to its calculated leaf, summing per payment profile.
// Calculate fallback amounts with the source price, before merging communes.
export const aggregateContractItemPayments = (payments, items) => {
  const sourceLeaves = new Map();
  const visit = (rows) => rows.forEach((item) => {
    if (item.children?.length) visit(item.children);
    else if (!item.hasChildren) (item.sourceItems || []).forEach((source) => sourceLeaves.set(source.itemId, { source, itemId: item.itemId }));
  });
  visit(items);
  const groups = new Map();
  payments.forEach((payment) => {
    const match = sourceLeaves.get(payment.contractItemId);
    if (!match) return;
    const key = JSON.stringify([match.itemId, payment.paymentProfileId]);
    const current = groups.get(key) || {
      contractItemId: match.itemId,
      paymentProfileId: payment.paymentProfileId,
      paymentQuantity: 0,
      paymentAmount: 0,
    };
    current.paymentQuantity += Number(payment.paymentQuantity || 0);
    current.paymentAmount += Number(payment.paymentAmount) > 0
      ? Math.round(Number(payment.paymentAmount))
      : Math.round(Number(match.source.unitPrice || 0) * Number(payment.paymentQuantity || 0));
    groups.set(key, current);
  });
  return [...groups.values()];
};
